import React from "react";
import { Grid, Typography } from "@mui/material";
export const FormHeading = ({ classes, title, id }) => {
    return (
        <Grid alignItems="center" className={classes.marginBottom}>
            <Typography
                className={classes.title}
                id={id}
                variant="h4"
                sx={{ fontSize: "24px" }}
                noWrap
            >
                {title}
            </Typography>
        </Grid>
    );
};
